import { FieldArrayRenderProps, useFormikContext } from 'formik'
import { ISaveServicesForLaterFormModel } from '../../../FormContents/typings'

type Props = {
  arrayHelpers: FieldArrayRenderProps
}

export function useHandlers(props: Props) {
  const { arrayHelpers } = props
  const { values } = useFormikContext<ISaveServicesForLaterFormModel>()

  function handleCheckboxChange(
    event: React.ChangeEvent<HTMLInputElement>,
    checked: boolean,
  ) {
    const value = event.target.value

    if (checked) {
      arrayHelpers.push(value)
    } else {
      const index = values.serviceIds.indexOf(value)
      if (index > -1) {
        arrayHelpers.remove(index)
      }
    }
  }

  return { handleCheckboxChange }
}
